import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogActions, Button, useTheme,
  useMediaQuery, DialogContent, Box, TextField, FormControlLabel, Switch } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dataset } from './Dataset';
import DatasetList from './DatasetList';

export interface DatasetDialogProps {
  open: boolean;

  onClose: () => void;
  onSubmit ?: (dataset: Dataset | undefined) => void;
}

export default function DatasetDialog(props: DatasetDialogProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [searchString, setSearchString] = useState<string>("");
  const [selectedDataset, setSelectedDataset] = useState<Dataset | undefined>();
  const [viewShared, setViewShared] = useState<boolean>(true);
  const [searchField, setSearchField] = useState<string>("name");

  useEffect(() => {
    if (!props.open) {
      // If the dialog is closing, clear out the previous search value.
      setSearchString("");
    }
  }, [props.open]);

  return (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    fullScreen={isSmallScreen}
    fullWidth={true}
    maxWidth="md"
    sx={{
      margin:{xs:0, sm:0},
    }} >
    <DialogTitle>
      {i18n.t('resources.datasets.list-title')}
      <Box sx={{float:'right', marginTop: "-15px"}}>
        <Box sx={{display:'inline-block', verticalAlign:'bottom', mr:2}}>
          <FormControlLabel
              control={
                <Switch
                  checked={viewShared}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setViewShared(event.target.checked);
                  }}/>
              }
              label={i18n.t("resource-action.view-shared")}
              />
        </Box>
        <Box sx={{display:'inline-block', verticalAlign:'middle'}}>
          <TextField
            autoComplete="off"
            label={`${i18n.t('search')}...`}
            variant="standard"
            value={searchString || ""}
            onChange={((event: React.ChangeEvent<HTMLInputElement>) => {
              setSearchString(event.target.value);
            })}/>
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent sx={{
      p: isSmallScreen ? 0 : 3,
      pt:1, pb: 1,
      backgroundColor: theme.palette.background.default,
    }} dividers>
      <DatasetList
        viewShared={viewShared}
        searchString={searchString}
        searchField={searchField}
        selectedDataset={selectedDataset}
        setSelectedDataset={(dataset: Dataset | undefined) => {
          // If the dataset is already selected, submit the form
          if (dataset === selectedDataset) {
            if (props.onSubmit) {
              props.onSubmit(dataset);
            }
          } else {
            // Otherwise, just set the selected dataset
            setSelectedDataset(dataset);
          }
        }}/>
    </DialogContent>
    <DialogActions>
      <Button
        variant="outlined"
        onClick={props.onClose}>
        {i18n.t('cancel')}
      </Button>
      <Button
        disabled={!selectedDataset}
        variant="contained"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (props.onSubmit) {
            props.onSubmit(selectedDataset);
          }
        }}>
        {i18n.t('submit')}
      </Button>
    </DialogActions>
  </Dialog>
  );
}
